import {editableFields} from './domain.js';
import {defaultBody} from './articleStructure.js';

export function versionFields(term){return Object.fromEntries(editableFields.map(key=>[key,key==='body'?(term.body??defaultBody(term)):(term[key]??'')]));}
